<template>
  <!-- <v-card flat class="v-card__container"> -->
  <v-card flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
      <v-card flat class="v-card__container">
        <v-card-title class="no-margins">
          <h4>Beställningar</h4>
          <v-spacer></v-spacer>
          <MessageBox v-if="showWarning" type="alert" :width="'100%'">
            <h5>DET FINNS BESTÄLLNINGAR SOM MÅSTE GODKÄNNAS INOM DE NÄRMSTA DAGARNA</h5>
            <p>
              Beställningarna måste godkännas inom utsatt tid för att inte riskera att lärlingens e-bok inaktiveras.
              Beställningarna det gäller är gulmarkerade i tabellen.
            </p>
          </MessageBox>
          <v-text-field
            v-model="search"
            @keydown.enter="doSearch()"
            clearable
            prepend-icon="$sl-search"
            placeholder="Sök i listan"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text class="mt-4 no-margins">
          <v-row no-gutters>
            <v-col md="auto" :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
              <OrderStateCriteria v-model="advSearch.stateId" />
            </v-col>
            <v-col md="auto" class="ml-4" :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
              <DatePicker
                :required="false"
                :clearable="true"
                label="Från beställningsdatum"
                v-model="advSearch.fromDate"
              />
            </v-col>
            <v-col md="auto" class="ml-4" :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
              <DatePicker
                :required="false"
                :clearable="true"
                label="Till beställningsdatum"
                v-model="advSearch.toDate"
              />
            </v-col>
            <!-- <v-col class="text-right mt-2">
              <v-btn @click="doSearch()">Sök</v-btn>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col class="d-block">
              <v-btn @click="createAccountingPrintOrder()" :disabled="isLoading">
                <v-icon>$sl-accounting-invoice</v-icon>
                Skapa bokföringsorder
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="orders"
      @update:options="options = $event"
      :server-items-length="totalRows"
      :items-per-page="itemsPerPage"
      :search="search"
      item-key="orderId"
      class="mt-6 mx-6 clickable"
      :item-class="getColor"
      sort-by="updatedAt"
      v-model="selected"
      show-select
      @click:row="clickOrder"
    >
      <!-- Order id header -->
      <template slot="item.orderId" slot-scope="props">
        <div style="text-align: right; padding-right: 28px">
          <router-link
            :to="{
              name: ( !get(props, 'item.printType', null) ? 'OrderDetail' : 'PrintOrderDetail' ),
              params: {id: props.item.id ? props.item.id : -1, type: props.item.type.toLowerCase()}
            }"
            >{{ props.item.orderId }}</router-link
          >
        </div>
      </template>
      <!-- Order type header -->
      <template slot="item.printType" slot-scope="props">
        <div style="min-width: 100px">{{ getTypeName(props.item) }}</div>
      </template>
      <!-- Company id header -->
      <template slot="item.companyName" slot-scope="props">
        <div style="min-width: 150px">
          <router-link :to="'/companies/' + props.item.companyId || ''">{{ props.item.companyName || '' }}</router-link>
        </div>
        <!-- <div style="min-width: 150px">{{ props.item.companyName || '' }}</div> -->
      </template>
      <!-- Region id header -->
      <template slot="item.regionName" slot-scope="props">
        <div style="min-width: 150px">{{ props.item.regionName || '' }}</div>
      </template>
      <!-- Contact Person id header -->
      <template slot="item.lastName" slot-scope="props">
        <div
          style="min-width: 150px"
          v-if="props.item && props.item.firstName && props.item.lastName"
        >
          <router-link v-if="props.item.personId" :to="'/people/' + props.item.personId">{{
            props.item.firstName + ' ' + props.item.lastName
          }}</router-link>
          <div v-else>{{ props.item.firstName + ' ' + props.item.lastName }}</div>
        </div>
        <div style="min-width: 150px" v-else-if="props.item && props.item.firstName && props.item.lastName">
          <router-link v-if="props.item.personId" :to="'/people/' + props.item.personId">{{ props.item.firstName + ' ' + props.item.lastName }}</router-link>
        <div v-else>{{ props.item.firstName + ' ' + props.item.lastName }}</div>
        </div>
      </template>
      <!-- Person id header -->
      <template slot="item.personId" slot-scope="props">{{ props.item | fullName }}</template>
      <!-- Order createdAt header -->
      <template slot="item.createdAt" slot-scope="props">
        <div style="min-width: 130px">{{ props.item.createdAt | date }}</div>
      </template>
      <!-- Order stateName header -->
      <template slot="item.stateName" slot-scope="props">
        <div class="d-flex align-center justify-space-between" @click.stop="showOrderInfoModal(props.item)">
          <div
            v-if="props.item.type == 'PrintOrder'"
            style="min-width: 150px"
            :class="`state print-state-${props.item.state}`"
          >
            {{ props.item.stateName || '' }}
          </div>
          <div v-else style="min-width: 150px" :class="`state print-state-${props.item.state}`">{{ props.item.stateName || '' }}</div>

          <v-icon class="ml-1">$sl-information-circle</v-icon>
        </div>
      </template>

      <!-- Order orderedAt header -->
      <template slot="item.orderedAt" slot-scope="props">
        <div style="width: 130px">{{ get(props, 'item.orderedAt', null) || get(props, 'item.createdAt', null) | date }}</div>
      </template>

    </v-data-table>
    <v-card-text class="mt-n6 mb-8">* Datum anger det datum beställningen skickats till företaget.</v-card-text>

    <v-card-actions>
      <v-btn class="mr-2" color="secondary" @click="doDownload('xml')" :disabled="!selected.length > 0">
        <v-icon>$sl-download</v-icon>Ladda ned importfil för valda
      </v-btn>
      <v-btn color="secondary" @click="doDownload('xlsx')" :disabled="!selected.length > 0">
        <v-icon>$sl-excel</v-icon>Ladda ned Excelfil för valda
      </v-btn>
    </v-card-actions>
    <OrderInfoModal v-if="order" @close="closeOrderInfoModal" :showInfo="showOrderInfo" :order="order" />
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import MessageBox from '@/components/common/MessageBox.vue'
import {mapGetters, mapActions} from 'vuex'
import {pageSize} from '@/store/constants'
import {DownloadsMixin, PrintsMixin} from '@/components/mixins'
import Criterias from '@/components/mixins/Criterias'
import OrderStateCriteria from '@/components/order/OrderStateCriteria'
import DatePicker from '@/components/common/DatePicker'
import OrderInfoModal from '@/pages/order/OrderInfoModal.vue'
import get from 'lodash/get'

const SugarDate = require('sugar/date')

// @group Order
// OrderList component
export default {
  name: 'OrderList',

  mixins: [DownloadsMixin, Criterias, PrintsMixin],
  components: {
    DatePicker,
    OrderStateCriteria,
    MessageBox,
    OrderInfoModal
  },
  data: () => ({
    search: '',
    selected: [],
    editedItem: {},
    options: {},
    itemsPerPage: pageSize,
    totalRows: 0,
    orders: [],
    showWarning: false,
    printOrders: [],
    combinedOrders: [],
    headers: [
      {text: 'Nr.', value: 'orderId', class: 'orderNo', width: "70" },
      {text: 'Typ', value: 'printType'},
      {text: 'Företag', value: 'companyName'},
      {text: 'Kontaktperson', value: 'lastName'},
      {text: 'Region', value: 'regionName'},
      {text: 'Status', value: 'stateName'},
      {text: 'Avser', value: 'lastName'},
      {text: 'Godkänn senast', value: 'latestApprovalDate', width: "160" },
      {text: 'Skickad*', value: 'orderedAt'}
    ],
    advSearch: {
      stateId: []
    },
    //- For fragment criterias
    criteria: {},
    doneInitialSearch: false,
    order: null,
    showOrderInfo: false
  }),

  created() {
    // @vuese
    //- Get criteria from url hash fragment
    const locationCriteria = this.getCriteriaFromLocation('c')
    // @vuese
    //- Set values if we have a criteria
    if (locationCriteria) {
      this.criteria = locationCriteria
      this.search = this.criteria.search
      this.advSearch = this.criteria.advSearch
      this.options = {
        page: this.criteria.page,
        itemsPerPage: this.criteria.pageSize,
        sortBy: [this.criteria.sortBy],
        sortDesc: [this.criteria.sortDesc]
      }
    }
  },

  computed: {
    ...mapGetters('app', ['isLoading'])
  },

  watch: {
    options: {
      handler(newOptions, oldOptions) {
        const pageChanged = oldOptions.page !== newOptions.page
        this.fetchListOptions(pageChanged)
      },
      deep: true
    },
    'advSearch.fromDate': {
      handler: function (newVal, oldVal) {
        if ( newVal || oldVal )
          this.doSearch()
      }
    },
    'advSearch.toDate': {
      handler: function (newVal, oldVal) {
        if ( newVal || oldVal )
          this.doSearch()
      }
    },
    'advSearch.stateId': {
      handler: function (newVal, oldVal) {
        if ( newVal?.length || oldVal?.length )
          this.doSearch()
      }
    },
    'search': {
      handler: function (newVal, oldVal) {
        if ( newVal || oldVal )
          this.doSearch()
      }
    }
  },

  methods: {
    get,

    ...mapActions('order', ['setSelectedOrder']),

    createAccountingPrintOrder() {
      return this.fetchList(null, 500)
      .then(() => {
        this.newPrintOrdersTable(this.orders)
      })
    },

    getTypeName(item) {
      if (item.type === 'ExtensionOrder') {
        return 'Förlängning grundutbildning';
      }

      return item.type == 'PrintOrder'? (item.printType=='TradeCertificate' ? 'Yrkesbeviskort' :'Maskinkort') :'Distansutbildning lärling'
    },

    getColor(item) {
      if (
        item.latestApprovalDate &&
        item.professionId &&
        item.professionDaysUntilOrderApproval &&
        Number(item.professionDaysUntilOrderApproval) > 0
      ) {
        let daysFromNow = SugarDate.Date(item.latestApprovalDate).daysFromNow()
        let halfTime = item.professionDaysUntilOrderApproval / 2

        if (daysFromNow < halfTime) return 'yellow'
      }
      return
    },

    fetchListOptions(pageChanged) {
      if (!pageChanged && this.options.page > 1) {
        this.options.page = 1
      } else {
        this.fetchList()
      }
    },
    // @vuese
    //- Used to download distance order xml , xmls or json
    doDownload(type) {
      API.exportDistanceOrders({
        selectedOrders: this.selected.map(o => {
          return o.id
        }),
        exportType: type
      })
        .then(response => {
          const filename = 'orders'
          const blob = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}))
          switch (type) {
            case 'xml':
              this.downloadFile(filename + '.xml', blob)
              break
            case 'xlsx':
              this.downloadFile(filename + '.xlsx', blob)
              break
            default:
              this.downloadFile(filename + '.json', blob)
              break
          }
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },

    doSearch(value) {
      this.fetchList(value)
    },
    // @vuese
    // Used to fetch list distance orders
    // @arg The argument is object representing search criteries
    async fetchList(search, pageSize = 30) {
      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      const startAt = (page - 1) * this.itemsPerPage

      this.selected = []

      this.criteria = {
        page: page,
        startAt: startAt,
        sortBy: sortBy[0],
        sortDesc: (sortDesc[0] === true) ? false : true, //- Revert order to correspond to 'up' and 'down' - arrow sign 
        search: this.search,
        advSearch: { ...this.advSearch, stateId: this.advSearch.stateId?.includes(4) ? [ ...this.advSearch.stateId, 6 ] : this.advSearch.stateId },
        pageSize
      }

      return API.listOrders(this.criteria)
        .then(async response => {
          this.setCriteriaToLocation('c', this.criteria)
          this.orders = await response.data.rows?.filter(it => it.printType === 'MachineCertificate' || it.stateId != 1);
          this.showWarning = response.data.rows.find(
            r =>
              r.latestApprovalDate &&
              r.professionId &&
              r.professionDaysUntilOrderApproval &&
              r.professionDaysUntilOrderApproval > 0 &&
              SugarDate.Date(r.latestApprovalDate).daysFromNow() < Number(r.professionDaysUntilOrderApproval) / 2
          )
          this.totalRows = await response.data.count
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },

    async clickOrder(item) {
      const getName = () => {
        switch (item.type) {
          case 'DistanceOrder': {
            return 'OrderDetail';
          }
          case 'ExtensionOrders': {
            return 'ExtensionOrder';
          }
          case 'PrintOrder': {
            return 'PrintOrderDetail';
          }
          default: {
            return 'OrderDetail';
          }
        }
      }

      // Clear previous one
      await this.setSelectedOrder(null)

      this.$nextTick(() => this.$router.push({name: getName(), params: {id: item.id ? item.id : -1}}))
    },
    showOrderInfoModal(item) {
      this.order = item
      this.showOrderInfo = true
    },
    closeOrderInfoModal() {
      this.showOrderInfo = false
      this.order = null
    }
  }
}
</script>
